// colorsD.js

const colorsD = {
  background: {
    default: "#f8f9fa",
    light: "#ffffff", // Lighter shade
    dark: "#e0e0e0", // Darker shade
    contrastText: "#000000", // Text contrasting with the main color
    paper: "#ffffff",
  },

  text: {
    main: "#67748e",
    focus: "#67748e",
    light: "#8795a8", // Lighter shade
    dark: "#4e5d74", // Darker shade
    contrastText: "#ffffff", // Text contrasting with the main color
  },

  transparent: "transparent",

  white: {
    main: "#ffffff",
    focus: "#ffffff",
    light: "#f8f9fa",
    dark: "#e0e0e0",
    contrastText: "#000000",
  },

  black: {
    light: "#141414",
    main: "#000000",
    focus: "#000000",
    dark: "#0a0a0a",
    contrastText: "#ffffff",
  },

  primary: {
    main: "#00693E",
    focus: "#0d764b",
    light: "#45a068",
    dark: "#004d2a",
    contrastText: "#ffffff",
  },

  secondary: {
    main: "#8392ab",
    focus: "#96a2b8",
    light: "#a8b4c3",
    dark: "#677a8a",
    contrastText: "#000000",
  },

  info: {
    main: "#17c1e8",
    focus: "#3acaeb",
    light: "#65e4f3",
    dark: "#1194b2",
    contrastText: "#000000",
  },

  success: {
    main: "#82d616",
    focus: "#95dc39",
    light: "#a8eb5b",
    dark: "#5ba10f",
    contrastText: "#000000",
  },

  warning: {
    main: "#fbcf33",
    focus: "#fcd652",
    light: "#fde673",
    dark: "#b8971f",
    contrastText: "#000000",
  },

  error: {
    main: "#ea0606",
    focus: "#c70505",
    light: "#ff4f4f",
    dark: "#a50404",
    contrastText: "#ffffff",
  },

  light: {
    main: "#e9ecef",
    focus: "#e9ecef",
    light: "#f1f3f5",
    dark: "#b8bfc6",
    contrastText: "#000000",
  },

  dark: {
    main: "#121212", // Base color
    light: "#1f1f1f", // Lighter shade
    dark: "#0d0d0d", // Darker shade
    focus: "#1a1a1a", // Focus state
    contrastText: "#ffffff", // Text color for contrast
  },

  grey: {
    100: "#f8f9fa",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
    light: "#ffffff",
    dark: "#1b1b1b",
    contrastText: "#000000",
  },

  gradients: {
    primary: {
      main: "#00693E",
      state: "#e0d000",
    },
    secondary: {
      main: "#627594",
      state: "#a8b8d8",
    },
    info: {
      main: "#2152ff",
      state: "#21d4fd",
    },
    success: {
      main: "#17ad37",
      state: "#98ec2d",
    },
    warning: {
      main: "#f53939",
      state: "#fbcf33",
    },
    error: {
      main: "#ea0606",
      state: "#ff667c",
    },
    light: {
      main: "#ced4da",
      state: "#ebeff4",
    },
    dark: {
      main: "#141727",
      state: "#3a416f",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },
    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },
    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },
    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },
    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },
    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },
    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },
    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },
    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },
    github: {
      main: "#24292e",
      dark: "#171a1d",
    },
    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },
    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#7928ca",
      state: "#d6006c",
      border: "#efb6e2",
    },
    secondary: {
      main: "#627594",
      state: "#8ca1cb",
      border: "#dadee6",
    },
    info: {
      main: "#2152ff",
      state: "#02c6f3",
      border: "#b9ecf8",
    },
    success: {
      main: "#17ad37",
      state: "#84dc14",
      border: "#daf3b9",
    },
    warning: {
      main: "#f53939",
      state: "#fac60b",
      border: "#fef1c2",
    },
    error: {
      main: "#ea0606",
      state: "#ff3d59",
      border: "#f9b4b4",
    },
    light: {
      main: "#ced4da",
      state: "#d1dae6",
      border: "#f8f9fa",
    },
    dark: {
      main: "#141727",
      state: "#2c3154",
      border: "#c2c8d1",
    },
  },

  badgeColors: {
    primary: {
      background: "#f883dd",
      text: "#a3017e",
    },
    secondary: {
      background: "#e4e8ed",
      text: "#5974a2",
    },
    info: {
      background: "#abe9f7",
      text: "#08a1c4",
    },
    success: {
      background: "#cdf59b",
      text: "#67b108",
    },
    warning: {
      background: "#fef5d3",
      text: "#fbc400",
    },
    error: {
      background: "#fc9797",
      text: "#bd0000",
    },
    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },
    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },
  action: {
    disabledBackground: "#e0e0e0", // Custom disabled background color
    hover: "rgba(0, 0, 0, 0.08)", // Custom hover color for buttons
  },

  inputColors: {
    borderColor: { main: "#d2d6da", focus: "#35d1f5" },
    boxShadow: "#81e3f9",
    error: "#fd5c70",
    success: "#66d432",
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
  footer1:{
    body: '#d0d0d0',          // Light Grey for body text
    heading: '#ffffff',       // Light Grey for headings
    background: {
      from: '#1c1c1c',        // Very Dark Grey gradient start
      to: '#424242',          // Dark Grey gradient end
    },
  },
  footerDefault: {
    body: '#888888',          // Dark Grey for body text
    heading: '#444444',       // Slightly darker Grey for headings
    background: {
      from: '#ffffff',        // White gradient start
      to: '#f0f0f0',          // Very Light Grey gradient end
    },
  }

};

export default colorsD;
